import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-h4" }, "Продовольственный план", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Прод. категория"),
    /*#__PURE__*/_createElementVNode("th", null, "Поставка"),
    /*#__PURE__*/_createElementVNode("th", null, "Фактическое потребление"),
    /*#__PURE__*/_createElementVNode("th", null, "Остаток/Потребность")
  ])
], -1)

import { computed, ref } from 'vue'
import {
  AppAuthService,
  Logger,
  PRODUCT_CATEGORIES_INFO,
  ProductPlansService,
  ProductReport,
  RealDateTimeProvider,
  Permissions,
  PRODUCT_CATEGORIES_REPORTS_UNITS,
} from '@prodcard/core'
import NewSupplyForm from './NewSupplyForm.vue'
import { Workbook } from 'exceljs'
import { createSheetProductPlan } from './createSheetProductPlan'
import { saveWorkbook } from '../../../common'
import { asyncHandleError, createCtx, handleError, monthsMock, yearsMock } from '../../../helpers'
import { useAuthPermissions } from '../../../mixins'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPlanTab',
  props: {
    productPlansService: {},
    authService: {}
  },
  emits: ['new-supply'],
  setup(__props: any, { emit: emits }) {

const props = __props;

const logger = new Logger('ProductPlanTab')



const { hasPermissions } = useAuthPermissions(props.authService)
const hasManage = computed(() => hasPermissions(Permissions.PRODUCT_SUPPLIES_MANAGE))
const hasTableExport = computed(() => hasPermissions(Permissions.PRODUCT_SUPPLIES_TABLE_EXPORT))



const now = new RealDateTimeProvider().get()
const searchParams = ref({
  month: now.getUTCMonth(),
  year: now.getUTCFullYear(),
})

const isLoading = ref(false)
const loadingTableToDownload = ref(false)
const showAddDialog = ref(false)

const productReports = ref<ProductReport[]>([])

const search = () =>
  asyncHandleError(async () => {
    const resp = await props.productPlansService.planReport(createCtx(), { filter: searchParams.value })
    productReports.value = resp
  }, isLoading)

search().catch(e => logger.error({}, '<026d31b7> Error', { error: e }))

const update = (e: Event, reset?: boolean) => {
  if (reset) {
    Object.assign(searchParams.value, {
      month: undefined,
      year: undefined,
    })
  }
  search().catch(e => logger.error({}, '<dcd4440a> Error', { error: e }))
}

const onNewSupply = async () => {
  await search()
  showAddDialog.value = false
  emits('new-supply')
}

const downloadTable = () => {
  handleError(async () => {
    const workbook = new Workbook()
    createSheetProductPlan(workbook, 'Продовольственный план', productReports.value)

    await saveWorkbook(workbook, 'Продовольственный_план')
  }, loadingTableToDownload)
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "my-5" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: searchParams.value.year,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.year) = $event)),
                      items: _unref(yearsMock),
                      label: "Год",
                      density: "comfortable",
                      clearable: ""
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: searchParams.value.month,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.month) = $event)),
                      items: _unref(monthsMock),
                      label: "Месяц",
                      density: "comfortable",
                      clearable: ""
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "auto" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              variant: "text",
              icon: "mdi-magnify",
              onClick: update,
              loading: isLoading.value
            }, null, 8, ["loading"]),
            _createVNode(_component_v_btn, {
              variant: "text",
              icon: "mdi-restore",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (update($event, true))),
              disabled: isLoading.value
            }, null, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      loading: isLoading.value,
      disabled: isLoading.value,
      class: "mt-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_table, { class: "" }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productReports.value, (productReport) => {
                return (_openBlock(), _createElementBlock("tr", { key: productReport }, [
                  _createElementVNode("td", null, _toDisplayString(`${_unref(PRODUCT_CATEGORIES_INFO)[productReport.category].description} ${
                    _unref(PRODUCT_CATEGORIES_REPORTS_UNITS)[productReport.category] || ''
                  }`), 1),
                  _createElementVNode("td", null, _toDisplayString(productReport.supply), 1),
                  _createElementVNode("td", null, _toDisplayString(productReport.consumption), 1),
                  _createElementVNode("td", null, _toDisplayString(productReport.balance), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading", "disabled"]),
    _createVNode(_component_v_row, { class: "mt-2" }, {
      default: _withCtx(() => [
        (hasManage.value)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showAddDialog.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Внести данные")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (hasTableExport.value)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 1,
              cols: "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "outlined",
                  "prepend-icon": "mdi-download-outline",
                  loading: loadingTableToDownload.value,
                  disabled: isLoading.value,
                  onClick: downloadTable
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Скачать ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (hasManage.value)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: showAddDialog.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showAddDialog).value = $event)),
          disabled: isLoading.value,
          width: "500"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "pa-5",
              variant: "flat"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_actions, { class: "justify-end align-start pa-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showAddDialog.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Закрыть")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(NewSupplyForm, {
                  "product-plans-service": _ctx.productPlansService,
                  onNewSupply: onNewSupply,
                  onCancel: _cache[5] || (_cache[5] = ($event: any) => (showAddDialog.value = false))
                }, null, 8, ["product-plans-service"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})